import { Kb3dModel } from '../decorators/kb3d-decorator';
import { ISvgTextureLayer } from '../kb3d-models';
import { Token } from '../token';
import { TextureLayer } from './texture-layer';

@Kb3dModel<SvgTextureLayer>({
    token: Token.SvgTextureLayer,
})
export class SvgTextureLayer extends TextureLayer implements ISvgTextureLayer {
    svgXml = '';
    height = 256;
    width = 256;
    preloadFontStylesheet = '';

    _raster?: ImageBitmap;
}
